import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { BECOME_USER_DELEGATE, FETCH_USER_DELEGATE } from '../actions/actionTypes';
import {
  becomeUserDelegateDone,
  becomeUserDelegateError,
  becomeUserDelegateLoading,
  becomeUserDelegateSuccess,
  fetchUserDelegateDone,
  fetchUserDelegateError,
  fetchUserDelegateLoading,
  fetchUserDelegateSuccess
} from '../actions/userDelegate';
import { userDelegateApi } from '../api/UserDelegateApi';

// Create your Saga here...

export function* watchFetchUserDelegateSaga () {
  yield takeLatest(FETCH_USER_DELEGATE, fetchUserDelegateSaga);
}

export function* fetchUserDelegateSaga (/* add parameters */) {
  try {
    yield put(fetchUserDelegateLoading());
    const delegates = yield call(userDelegateApi.getMyDelegates);
    yield put(fetchUserDelegateSuccess(delegates));
  } catch (error) {
    yield put(fetchUserDelegateError(error));
  } finally {
    yield put(fetchUserDelegateDone());
  }
}

export function* watchBecomeSaga () {
  yield takeLatest(BECOME_USER_DELEGATE, becomeSaga);
}

export function* becomeSaga ({ userId }) {
  try {
    yield put(becomeUserDelegateLoading());
    const user = yield call(userDelegateApi.become, userId);
    yield put(becomeUserDelegateSuccess(user));
  } catch (error) {
    yield put(becomeUserDelegateError(error));
  } finally {
    yield put(becomeUserDelegateDone());
  }
}

export default [
  fork(watchFetchUserDelegateSaga),
  fork(watchBecomeSaga)
];
